<template>
  <div class="container">
    <div class="content">
      <indexList
        :showTitle="showTitle"
        :showPage="showPage"
        :showTime="showTime"
        :toSpan="'dynamics'"
        :type="2"
      ></indexList>
    </div>
  </div>
</template>

<script>
import indexList from "../components/indexList";
export default {
  components: {
    indexList,
  },
  name: "dynamic",
  data() {
    return {
      showTitle: "协会动态",
      showPage: "showPage",
      showTime: "showTime",
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  min-height: 950px;

  .content {
    // border: 1px solid #ccc;
    border-radius: 1px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    // width: 70%; //固定宽度改为百分比
    width: 1200px;
    background: #fff;
    z-index: 99;
  }
}
</style>